module.exports = __webpack_public_path__ + "fonts/poppins-semibold-webfont.717660bc.woff2";